import { Descriptions as AntdDescriptions } from "antd";
import styled from "styled-components";
export const Descriptions = styled(AntdDescriptions)`
  .ant-descriptions-view {
    border-radius: ${(props) => props.bordered ? props.theme.border.radius : "none"};
  }
`;
